var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-tooltip',{attrs:{"placement":"topLeft"}},[(_vm.ellipsis)?_c('template',{slot:"title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('span',{ref:"content"},[(_vm.content)?[_vm._v(_vm._s(_vm.content))]:_vm._t("default")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }